<template>
  <div id="app">
    <div class="body_bg">
      <ArticleTitle></ArticleTitle>
    </div>
  </div>
</template>

<script>
import ArticleTitle from '../components/ArticleTitle'
export default {
  data() {
    return {
      checked: true,
      form: {
        desc: '',
      },
    }
  },
  components: {
    ArticleTitle,
  },
  methods: {
    onSubmit() {},
  },
}
</script>

<style scoped></style>
